import { BRAND } from "../../shared/brand";

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark" aria-label={BRAND.name}>
      <span className="brand-mark__symbol" aria-hidden="true">
        <span>M</span>
      </span>
      {!compact && (
        <span className="brand-mark__copy">
          <strong>{BRAND.name}</strong>
          <small>{BRAND.tagline}</small>
        </span>
      )}
    </div>
  );
}
